import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import { useParams } from "react-router-dom";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import "../App.css";
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ApiUrl } from '../Constants/Weburl';
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";
import CustomSwitch from "../components/Customswitch";
import CustomPagination from '../components/Custompagination'
import CustomContainer from "../components/Customsettingscontain";
import CustomInput from '../components/Custominput';
import Layout from "../components/Layout";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";
import DeleteModal from "../components/DeleteModal";

export default function Posts() {


    const [activeType, setActiveType] = useState("all");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const filterUserId = searchParams.get("userId") || "";

    const [posts, setPosts] = useState([]);
    const [userposts, setUserposts] = useState([]);
    const [userReels, setUserReels] = useState([]);
    const [textposts, setTextposts] = useState([]);
    const [imageposts, setImageposts] = useState([]);
    const [videoposts, setVideoposts] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [viewPost, setViewPost] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteHandler, setDeleteHandler] = useState(null);

    const { toggleExpand, isExpanded } = useExpandableRows();


    const headers = [
        { label: "Content", className: 'pt-col-content' },
        { label: "Type", className: 'pt-col-type', field: "type" },
        { label: "User", className: 'pt-col-user', field: "user" },
        { label: "Description & Stats", className: 'pt-col-desc col-hide-3', field: "desc" },
        { label: "Created Date", className: 'pt-col-date col-hide-2', field: "date" },
        { label: "Action", className: 'pt-col-action col-hide-1', field: "action" },
    ]

    const hiddenFields = useHiddenColumns(".rr1-table", headers);



    const handleViewPosts = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken");

            if (!token) {
                alert("Admin login required");
                setLoading(false);
                return;
            }

            const userIdParam = filterUserId ? `&userId=${filterUserId}` : "";


            const response = await axios.get(
                `${ApiUrl}api/auth/adminpostss?page=${page}&limit=${limit}${userIdParam}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Admin posts:", response.data);

            // setPosts(response.data.data); 
            setPosts(Array.isArray(response.data.data) ? response.data.data : []);

            // setTotalPages(response.data.pagination.totalPages);
            setTotalPages(response.data?.pagination?.totalPages || 1);

        } catch (error) {
            console.error(
                "Fetch admin posts error:",
                error.response?.data || error.message
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleViewPosts();
        fetchAllPosts();
        fetchAllReels();
    }, [page, limit]);

    useEffect(() => {
        fetchTextPosts();
        fetchimages();
        fetchVideos();
    }, [page, limit]);


    //posts api
    const fetchAllPosts = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken"); // user token
            const userIdParam = filterUserId ? `&userId=${filterUserId}` : "";


            const res = await axios.get(
                `${ApiUrl}api/auth/allposts?page=${page}&limit=${limit}${userIdParam}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("fetchposts", res.data.data);
            setUserposts(res.data.data);
            // setUserposts(Array.isArray(res.data.data) ? res.data.data : []);
            // setTotalPages(res.data.pagination.totalPages);

        } catch (err) {
            console.error("Fetch posts error:", err.response?.data || err.message);
        } finally {
            setLoading(false);
        }
    };


    //Reels api
    const fetchAllReels = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken"); // user token
            const userIdParam = filterUserId ? `&userId=${filterUserId}` : "";


            const res = await axios.get(
                `${ApiUrl}api/auth/allReels?page=${page}&limit=${limit}${userIdParam}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("fetchReels", res.data.data);
            setUserReels(res.data.data);
            // setTotalPages(res.data.pagination.totalPages);

        } catch (err) {
            console.error("Fetch posts error:", err.response?.data || err.message);
        } finally {
            setLoading(false);
        }
    };



    // const sampleReports = [
    //     {
    //         id: 1,
    //         reasonTitle: "Spam or misleading",
    //         reasons: "gderg",
    //         user: 'uma',
    //         description: 'good',
    //         date: "02 Dec 2025"
    //     },
    // ]

    //text based post api
    const fetchTextPosts = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            const userIdParam = filterUserId ? `&userId=${filterUserId}` : "";

            const res = await axios.get(
                `${ApiUrl}api/auth/text?page=${page}&limit=${limit}${userIdParam}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );


            setTextposts(res.data.data);
            console.log("fetchtext", res.data.data);
            // setTotalPages(res.data.pagination.totalPages);
        }
        catch (err) {
            console.error("Fetch text error:", err.response?.data || err.message);
        }
    };

    //image based post 
    const fetchimages = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            const userIdParam = filterUserId ? `&userId=${filterUserId}` : "";


            const res = await axios.get(
                `${ApiUrl}api/auth/image?page=${page}&limit=${limit}${userIdParam}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );


            setImageposts(res.data.data);
            console.log("fetchimages", res.data.data);
            // setTotalPages(res.data.pagination.totalPages);
        }
        catch (err) {
            console.error("Fetch text error:", err.response?.data || err.message);
        }
    };


    //video based post
    const fetchVideos = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            const userIdParam = filterUserId ? `&userId=${filterUserId}` : "";


            const res = await axios.get(
                `${ApiUrl}api/auth/video?page=${page}&limit=${limit}${userIdParam}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );


            setVideoposts(res.data.data);
            console.log("fetchvideo", res.data.data);
            // setTotalPages(res.data.pagination.totalPages);
        }
        catch (err) {
            console.error("Fetch text error:", err.response?.data || err.message);
        }
    };

    const renderDescription = (text) => {
        if (!text) return null;

        return text.split(/(@[a-zA-Z0-9_]+)/g).map((part, index) => {
            if (part.startsWith("@")) {
                return (
                    <span key={index} className="mention-text">
                        {part}
                    </span>
                );
            }

            return part;
        });
    };



    const getImageUrl = (img) => {
        if (!img) return "";
        if (img.startsWith("http")) return img;
        return `${ApiUrl}${img.replace("\\", "/")}`;
    };


    //delete adminuserIds
    const admindeletePost = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.delete(
                `${ApiUrl}api/auth/admindeletepost/${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            console.log("res admindeletepost", res.data)

            setPosts(prev => prev.filter(p => p.id !== id));

        } catch (error) {
            console.error("Delete post failed", error);
        }
    };


    //deletereel
    const deleteReel = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.delete(
                `${ApiUrl}api/auth/deletereel/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("deleteReel res", res.data);
            setUserReels(prev => prev.filter(r => r.id !== id));

        } catch (error) {
            console.error("Delete reel failed", error);
        }
    };


    //deletepost
    const deleteadminpost = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.delete(
                `${ApiUrl}api/auth/deleteadminpost/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("deleteadminpost res", res.data);
            setUserposts(prev => prev.filter(r => r.id !== id));

        } catch (error) {
            console.error("Delete post failed", error);
        }
    };


    //alltypedelete
    const deleteadminalltype = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.delete(
                `${ApiUrl}api/auth/deleteadminpost/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("deleteadminpost res", res.data);
            // setTextposts(prev => prev.filter(r => r.id !== id));
            if (activeType === "text") {
                setTextposts(prev => prev.filter(post => post.id !== id));
            }
            else if (activeType === "image") {
                setImageposts(prev => prev.filter(post => post.id !== id));
            }
            else if (activeType === "video") {
                setVideoposts(prev => prev.filter(post => post.id !== id));
            }
        } catch (error) {
            console.error("Delete post failed", error);
        }
    };

    const handleViewContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };


    const handlePostContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };

    const handleReelContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };

    const handleTextContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };

    const handleImageContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };

    const handleVideoContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };



    return (
        <Layout>
            <CustomContainer className="rr-wrapperhashtag">
                <div className="rr-card">
                    <div className="users-tabs-row">
                        <div className="activetab">
                            <CustomButton
                                className={`tab ${activeType === "all" ? "tab active" : "tab"}`}
                                onClick={() => setActiveType("all")}
                            >
                                All
                            </CustomButton>
                            <CustomButton
                                className={`tab ${activeType === "reels" ? "tab active" : "tab"}`}
                                onClick={() => setActiveType("reels")}
                            >
                                Reels
                            </CustomButton>
                            <CustomButton
                                className={`tab ${activeType === "posts" ? "tab active" : "tab"}`}
                                onClick={() => setActiveType("posts")}
                            >
                                Posts
                            </CustomButton>
                            <CustomButton
                                className={`tab ${activeType === "text" ? "tab active" : "tab"}`}
                                onClick={() => setActiveType("text")}
                            >
                                Text
                            </CustomButton>
                            <CustomButton
                                className={`tab ${activeType === "image" ? "tab active" : "tab"}`}
                                onClick={() => setActiveType("image")}
                            >
                                Image
                            </CustomButton>
                            <CustomButton
                                className={`tab ${activeType === "video" ? "tab active" : "tab"}`}
                                onClick={() => setActiveType("video")}
                            >
                                Videos
                            </CustomButton>
                        </div>

                        <div className="users-controls">
                            <div className="rr-left">
                                Show
                                <select
                                    className="rr-select"
                                    value={limit}
                                    onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setPage(1);
                                    }}
                                >
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                </select>
                                entries
                            </div>
                            <div className="rr-right">
                                <span>Search:</span>
                                <CustomInput
                                    className="rr-search"
                                    type="text"
                                    placeholder="Search posts"
                                />
                            </div>
                        </div>
                    </div>

                    <CustomTable className="rr1-table posts-table"
                        headers={headers}
                    >
                        {activeType === "all" && (
                            <>
                                {posts.map((item, idx) => (
                                    <React.Fragment key={item.id ?? idx}>
                                        <tr className="rr-actionshastag">
                                            <td className="profile-pill">
                                                {hiddenFields.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                        onClick={() => toggleExpand(item.id ?? idx)}
                                                        aria-label="Show more details"
                                                    >
                                                        {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                    </button>

                                                )}
                                                <button
                                                    className="view-btn"
                                                    onClick={() => handleViewContent(item)}
                                                >
                                                    <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                                </button>
                                            </td>
                                            <td className="pt-col-type">
                                                <span className="real-badge">{item.postType}</span>
                                            </td>
                                            <td className="pt-col-user">
                                                <div className="profile-pill">
                                                    <div className="avatar">
                                                        <img
                                                            src={getImageUrl(item?.user?.avatar)}
                                                            alt=""
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className="username">{item?.user?.username}</div>
                                                        <div className="subtext">{item?.user?.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="pt-col-desc rr-actions4 col-hide-3">
                                                <div className="likecommentsposts">
                                                    <div className="likecommentsdesign">
                                                        <span className="allspan">
                                                            <i class="bi bi-suit-heart" ></i><span>:</span>{item?.like_posts?.length}</span>
                                                    </div>
                                                    <div className="likecommentsdesign">
                                                        <span className="allspan">
                                                            <i class="bi bi-chat"></i>
                                                            <span>:</span>
                                                            {item.comments.length}
                                                        </span>
                                                    </div>
                                                    <div className="likecommentsdesign">
                                                        <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item?.save_posts.length}</span>
                                                    </div>
                                                    <div className="likecommentsdesign">
                                                        <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>
                                                    </div>
                                                </div>
                                                <p className="alldescriptiontext">
                                                    {renderDescription(item.description)}
                                                </p>
                                            </td>

                                            <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                            <td className="pt-col-action rr-actionsbutton col-hide-1">
                                                <CustomButton
                                                    reportclassName="rr-icon-btn green"
                                                    onClick={() => navigate(`/PostView/${item.id}`)}
                                                >
                                                    <i class="bi bi-eye"></i>
                                                </CustomButton>

                                                <CustomButton
                                                    reportclassName="rr-icon-btn red"
                                                    // onClick={() => admindeletePost(item.id)}
                                                    onClick={() => {
                                                        setDeleteId(item.id);
                                                        setDeleteHandler(() => admindeletePost);
                                                        setShowDeleteModal(true);
                                                    }}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </CustomButton>
                                            </td>
                                        </tr>


                                        {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={6}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>
                                                                {field === "type" && (
                                                                    <span className="real-badge">{item.postType}</span>
                                                                )}
                                                                {field === "user" && (
                                                                    <div className="profile-pill">
                                                                        <div className="avatar">
                                                                            <img
                                                                                src={getImageUrl(item?.user?.avatar)}
                                                                                alt=""
                                                                                style={{ width: 32, height: 32, borderRadius: "50%" }}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <div className="username">{item?.user?.username}</div>
                                                                            <div className="subtext">{item?.user?.name}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {field === "desc" && (
                                                                    <div>
                                                                        <div className="likecommentsposts">
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-suit-heart"></i><span>:</span>{item?.like_posts?.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-chat"></i>
                                                                                    <span>:</span>
                                                                                    {item.comments.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-bookmark"></i><span>:</span>{item?.save_posts.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-share"></i><span>:</span>{item.share_posts.length}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <p className="alldescriptiontext" style={{ margin: "8px 0 0" }}>
                                                                            {renderDescription(item.description)}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {field === "date" && (
                                                                    <span className="expand-value">
                                                                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                    </span>
                                                                )}
                                                                {field === "action" && (
                                                                    <div style={{ display: "flex", gap: 8 }}>
                                                                        <CustomButton reportclassName="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                                                                            <i className="bi bi-eye"></i>
                                                                        </CustomButton>
                                                                        <CustomButton reportclassName="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                                                                            <i className="bi bi-trash"></i>
                                                                        </CustomButton>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}

                                    </React.Fragment>
                                ))}
                            </>
                        )}
                        {/* </tbody> */}

                        {/* <tbody> */}
                        {activeType === "posts" && (
                            <>
                                {userposts.map((item, idx) => (
                                    <React.Fragment key={item.id ?? idx}>
                                        <tr className="rr-actionshastag">
                                            <td className="profile-pill">
                                                {hiddenFields.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                        onClick={() => toggleExpand(item.id ?? idx)}
                                                        aria-label="Show more details"
                                                    >
                                                        {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                    </button>

                                                )}
                                                <button
                                                    className="view-btn"
                                                    onClick={() => handlePostContent(item)}
                                                >
                                                    <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                                </button>
                                            </td>
                                            {/* <td>{item.postType}</td> */}
                                            <td className="pt-col-type">
                                                <span className="real-badge">{item.postType}</span>
                                            </td>
                                            {/* <td
                                            >
                                                <div className="chip">
                                                    <img
                                                        src={getImageUrl(item?.user?.avatar)}
                                                        alt=""
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                    <div>
                                                        <h5>{item?.user?.username}</h5>
                                                        <p>{item?.user?.name}</p>
                                                    </div>
                                                </div>
                                            </td> */}

                                            <td className="pt-col-user">
                                                <div className="profile-pill">
                                                    <div className="avatar">
                                                        <img
                                                            src={getImageUrl(item?.user?.avatar)}
                                                            alt=""
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className="username">{item?.user?.username}</div>
                                                        <div className="subtext">{item?.user?.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="pt-col-desc rr-actions4 col-hide-3"
                                            // className="rr-actions4"
                                            >

                                                <div className="likecommentsposts">

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts?.length}</span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-chat"></i>
                                                            <span>:</span>
                                                            {item.comments.length}
                                                        </span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                    </div>
                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                    </div>
                                                </div>

                                                {/* <h5 className="reason-title">{posts.title}</h5> */}
                                                {/* <p className="alldescriptiontext">{item.description}</p> */}
                                                <p className="alldescriptiontext">
                                                    {renderDescription(item.description)}
                                                </p>
                                            </td>



                                            <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                            <td className="pt-col-action rr-actionsbutton col-hide-1">
                                                <button
                                                    className="rr-icon-btn green"
                                                    onClick={() => navigate(`/PostView/${item.id}`)}
                                                >
                                                    <i class="bi bi-eye"></i>
                                                </button>

                                                <button
                                                    className="rr-icon-btn red"
                                                    onClick={() => deleteadminpost(item.id)}
                                                // onClick={() => deleteHashtag(item.id, item.tag)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>
                                        </tr>

                                        {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={6}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>
                                                                {field === "type" && (
                                                                    <span className="real-badge">{item.postType}</span>
                                                                )}
                                                                {field === "user" && (
                                                                    <div className="profile-pill">
                                                                        <div className="avatar">
                                                                            <img
                                                                                src={getImageUrl(item?.user?.avatar)}
                                                                                alt=""
                                                                                style={{ width: 32, height: 32, borderRadius: "50%" }}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <div className="username">{item?.user?.username}</div>
                                                                            <div className="subtext">{item?.user?.name}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {field === "desc" && (
                                                                    <p className="alldescriptiontext" style={{ margin: 0 }}>
                                                                        {renderDescription(item.description)}
                                                                    </p>
                                                                )}
                                                                {field === "date" && (
                                                                    <span className="expand-value">
                                                                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                    </span>
                                                                )}
                                                                {field === "action" && (
                                                                    <div style={{ display: "flex", gap: 8 }}>
                                                                        <CustomButton reportclassName="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                                                                            <i className="bi bi-eye"></i>
                                                                        </CustomButton>
                                                                        <CustomButton reportclassName="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                                                                            <i className="bi bi-trash"></i>
                                                                        </CustomButton>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                        {/* </tbody> */}


                        {/* <tbody> */}
                        {activeType === "reels" && (
                            <>
                                {userReels.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                            <strong>No reels have been posted yet</strong>
                                        </td>
                                    </tr>
                                ) : (
                                    userReels.map((item, idx) => (
                                        <React.Fragment key={item.id ?? idx}>
                                            <tr className="rr-actionshastag">
                                                <td className="profile-pill">
                                                    {hiddenFields.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                            onClick={() => toggleExpand(item.id ?? idx)}
                                                            aria-label="Show more details"
                                                        >
                                                            {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                        </button>

                                                    )}
                                                    <button
                                                        className="view-btn"
                                                        onClick={() => handleReelContent(item)}
                                                    >
                                                        <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                                    </button>
                                                </td>
                                                {/* <td
                                                >{item.postType}</td> */}
                                                <td className="pt-col-type">
                                                    <span className="real-badge">{item.postType}</span>
                                                </td>

                                                <td className="pt-col-user">
                                                    <div className="profile-pill">
                                                        <div className="avatar">
                                                            <img
                                                                src={getImageUrl(item?.user?.avatar)}
                                                                alt=""
                                                                style={{
                                                                    width: 40,
                                                                    height: 40,
                                                                    borderRadius: "50%",
                                                                }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className="username">{item?.user?.username}</div>
                                                            <div className="subtext">{item?.user?.name}</div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="pt-col-desc rr-actions4 col-hide-3"
                                                >

                                                    <div className="likecommentsposts">

                                                        <div className="likecommentsdesign">

                                                            <span className="allspan">
                                                                <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts?.length}</span>

                                                        </div>

                                                        <div className="likecommentsdesign">

                                                            <span className="allspan">
                                                                <i class="bi bi-chat"></i>
                                                                <span>:</span>
                                                                {item.comments.length}
                                                            </span>

                                                        </div>

                                                        <div className="likecommentsdesign">

                                                            <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                        </div>
                                                        <div className="likecommentsdesign">

                                                            <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                        </div>
                                                    </div>

                                                    {/* <h5 className="reason-title">{posts.title}</h5> */}
                                                    {/* <p className="alldescriptiontext">{item.description}</p> */}
                                                    <p className="alldescriptiontext">
                                                        {renderDescription(item.description)}
                                                    </p>
                                                </td>



                                                <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                                <td className="pt-col-action rr-actionsbutton col-hide-1">
                                                    <button
                                                        className="rr-icon-btn green"
                                                        onClick={() => navigate(`/PostView/${item.id}`)}
                                                    >
                                                        <i class="bi bi-eye"></i>
                                                    </button>

                                                    <button
                                                        className="rr-icon-btn red"
                                                        onClick={() => deleteReel(item.id)}
                                                    // onClick={() => deleteHashtag(item.id, item.tag)}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>

                                            {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                                <tr className="row-expand-details">
                                                    <td colSpan={6}>
                                                        <div className="expand-details">
                                                            {hiddenFields.map(({ field, label }) => (
                                                                <div className="expand-item" key={field}>
                                                                    <span className="expand-label">{label}</span>
                                                                    {field === "type" && (
                                                                        <span className="real-badge">{item.postType}</span>
                                                                    )}
                                                                    {field === "user" && (
                                                                        <div className="profile-pill">
                                                                            <div className="avatar">
                                                                                <img
                                                                                    src={getImageUrl(item?.user?.avatar)}
                                                                                    alt=""
                                                                                    style={{ width: 32, height: 32, borderRadius: "50%" }}
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <div className="username">{item?.user?.username}</div>
                                                                                <div className="subtext">{item?.user?.name}</div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {field === "desc" && (
                                                                        <div>
                                                                            <div className="likecommentsposts">
                                                                                <div className="likecommentsdesign">
                                                                                    <span className="allspan">
                                                                                        <i className="bi bi-suit-heart"></i><span>:</span>{item?.like_posts?.length}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="likecommentsdesign">
                                                                                    <span className="allspan">
                                                                                        <i className="bi bi-chat"></i>
                                                                                        <span>:</span>
                                                                                        {item.comments.length}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="likecommentsdesign">
                                                                                    <span className="allspan">
                                                                                        <i className="bi bi-bookmark"></i><span>:</span>{item?.save_posts.length}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="likecommentsdesign">
                                                                                    <span className="allspan">
                                                                                        <i className="bi bi-share"></i><span>:</span>{item.share_posts.length}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <p className="alldescriptiontext" style={{ margin: "8px 0 0" }}>
                                                                                {renderDescription(item.description)}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    {field === "date" && (
                                                                        <span className="expand-value">
                                                                            {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                        </span>
                                                                    )}
                                                                    {field === "action" && (
                                                                        <div style={{ display: "flex", gap: 8 }}>
                                                                            <CustomButton reportclassName="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                                                                                <i className="bi bi-eye"></i>
                                                                            </CustomButton>
                                                                            <CustomButton reportclassName="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                                                                                <i className="bi bi-trash"></i>
                                                                            </CustomButton>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))
                                )}
                            </>
                        )}
                        {/* </tbody> */}

                        {/* <tbody> */}
                        {activeType === "text" && (
                            <>
                                {textposts.map((item, idx) => (
                                    <React.Fragment key={item.id ?? idx}>
                                        <tr className="rr-actionshastag">
                                            <td className="profile-pill">
                                                {hiddenFields.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                        onClick={() => toggleExpand(item.id ?? idx)}
                                                        aria-label="Show more details"
                                                    >
                                                        {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                    </button>

                                                )}
                                                <button
                                                    className="view-btn"
                                                    onClick={() => handleTextContent(item)}
                                                >
                                                    <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                                </button>
                                            </td>
                                            <td className="pt-col-type"
                                            // className="rr-actions2"
                                            > <span className="real-badge">Text </span></td>
                                            {/* <td
                                            >
                                                <div className="chip">
                                                    <img
                                                        src={getImageUrl(item?.user?.avatar)}
                                                        alt=""
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                    <div>
                                                        <h5>{item?.user?.username}</h5>
                                                        <p>{item?.user?.name}</p>
                                                    </div>
                                                </div>
                                            </td> */}

                                            <td className="pt-col-user">
                                                <div className="profile-pill">
                                                    <div className="avatar">
                                                        <img
                                                            src={getImageUrl(item?.user?.avatar)}
                                                            alt=""
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className="username">{item?.user?.username}</div>
                                                        <div className="subtext">{item?.user?.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="pt-col-desc rr-actions4 col-hide-3">

                                                <div className="likecommentsposts">

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts?.length}</span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-chat"></i>
                                                            <span>:</span>
                                                            {item.comments.length}
                                                        </span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                    </div>
                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                    </div>
                                                </div>

                                                {/* <p className="alldescriptiontext">{item.description}</p> */}
                                                <p className="alldescriptiontext">
                                                    {renderDescription(item.description)}
                                                </p>
                                            </td>



                                            <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                            <td className="pt-col-action rr-actionsbutton col-hide-1">
                                                <button
                                                    className="rr-icon-btn green"
                                                    onClick={() => navigate(`/PostView/${item.id}`)}
                                                >
                                                    <i class="bi bi-eye"></i>
                                                </button>

                                                <button
                                                    className="rr-icon-btn red"
                                                    onClick={() => deleteadminalltype(item.id)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>
                                        </tr>

                                        {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={6}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>
                                                                {field === "type" && (
                                                                    <span className="real-badge">Text</span>
                                                                )}
                                                                {field === "user" && (
                                                                    <div className="profile-pill">
                                                                        <div className="avatar">
                                                                            <img
                                                                                src={getImageUrl(item?.user?.avatar)}
                                                                                alt=""
                                                                                style={{ width: 32, height: 32, borderRadius: "50%" }}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <div className="username">{item?.user?.username}</div>
                                                                            <div className="subtext">{item?.user?.name}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {field === "desc" && (
                                                                    <div>
                                                                        <div className="likecommentsposts">
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-suit-heart"></i><span>:</span>{item?.like_posts?.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-chat"></i>
                                                                                    <span>:</span>
                                                                                    {item.comments.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-bookmark"></i><span>:</span>{item?.save_posts.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-share"></i><span>:</span>{item.share_posts.length}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <p className="alldescriptiontext" style={{ margin: "8px 0 0" }}>
                                                                            {renderDescription(item.description)}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {field === "date" && (
                                                                    <span className="expand-value">
                                                                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                    </span>
                                                                )}
                                                                {field === "action" && (
                                                                    <div style={{ display: "flex", gap: 8 }}>
                                                                        <CustomButton reportclassName="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                                                                            <i className="bi bi-eye"></i>
                                                                        </CustomButton>
                                                                        <CustomButton reportclassName="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                                                                            <i className="bi bi-trash"></i>
                                                                        </CustomButton>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                        {/* </tbody> */}

                        {/* <tbody> */}
                        {activeType === "image" && (
                            <>
                                {imageposts.map((item, idx) => (
                                    <React.Fragment key={item.id ?? idx}>
                                        <tr className="rr-actionshastag">
                                            <td className="profile-pill">
                                                {hiddenFields.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                        onClick={() => toggleExpand(item.id ?? idx)}
                                                        aria-label="Show more details"
                                                    >
                                                        {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                    </button>

                                                )}
                                                <button
                                                    className="view-btn"
                                                    onClick={() => handleImageContent(item)}
                                                >
                                                    <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                                </button>
                                            </td>
                                            <td className="pt-col-type"
                                            // className="rr-actions2"
                                            > <span className="real-badge"> Image </span></td>
                                            {/* <td
                                            >
                                                <div className="chip">
                                                    <img
                                                        src={getImageUrl(item?.user?.avatar)}
                                                        alt=""
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                    <div>
                                                        <h5>{item?.user?.username}</h5>
                                                        <p>{item?.user?.name}</p>
                                                    </div>
                                                </div>
                                            </td> */}

                                            <td className="pt-col-user">
                                                <div className="profile-pill">
                                                    <div className="avatar">
                                                        <img
                                                            src={getImageUrl(item?.user?.avatar)}
                                                            alt=""
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className="username">{item?.user?.username}</div>
                                                        <div className="subtext">{item?.user?.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="pt-col-desc rr-actions4 col-hide-3">

                                                <div className="likecommentsposts">

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts?.length}</span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-chat"></i>
                                                            <span>:</span>
                                                            {item.comments.length}
                                                        </span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                    </div>
                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                    </div>
                                                </div>

                                                {/* <p className="alldescriptiontext">{item.description}</p> */}
                                                <p className="alldescriptiontext">
                                                    {renderDescription(item.description)}
                                                </p>
                                            </td>



                                            <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                            <td className="pt-col-action rr-actionsbutton col-hide-1">
                                                <button
                                                    className="rr-icon-btn green"
                                                    onClick={() => navigate(`/PostView/${item.id}`)}
                                                >
                                                    <i class="bi bi-eye"></i>
                                                </button>

                                                <button
                                                    className="rr-icon-btn red"
                                                    onClick={() => deleteadminalltype(item.id)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>
                                        </tr>


                                        {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={6}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>
                                                                {field === "type" && (
                                                                    <span className="real-badge">Image</span>
                                                                )}
                                                                {field === "user" && (
                                                                    <div className="profile-pill">
                                                                        <div className="avatar">
                                                                            <img
                                                                                src={getImageUrl(item?.user?.avatar)}
                                                                                alt=""
                                                                                style={{ width: 32, height: 32, borderRadius: "50%" }}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <div className="username">{item?.user?.username}</div>
                                                                            <div className="subtext">{item?.user?.name}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {field === "desc" && (
                                                                    <div>
                                                                        <div className="likecommentsposts">
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-suit-heart"></i><span>:</span>{item?.like_posts?.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-chat"></i>
                                                                                    <span>:</span>
                                                                                    {item.comments.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-bookmark"></i><span>:</span>{item?.save_posts.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-share"></i><span>:</span>{item.share_posts.length}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <p className="alldescriptiontext" style={{ margin: "8px 0 0" }}>
                                                                            {renderDescription(item.description)}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {field === "date" && (
                                                                    <span className="expand-value">
                                                                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                    </span>
                                                                )}
                                                                {field === "action" && (
                                                                    <div style={{ display: "flex", gap: 8 }}>
                                                                        <CustomButton reportclassName="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                                                                            <i className="bi bi-eye"></i>
                                                                        </CustomButton>
                                                                        <CustomButton reportclassName="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                                                                            <i className="bi bi-trash"></i>
                                                                        </CustomButton>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                        {/* </tbody> */}

                        {/* <tbody> */}
                        {activeType === "video" && (
                            <>
                                {videoposts.map((item, idx) => (
                                    <React.Fragment key={item.id ?? idx}>
                                        <tr className="rr-actionshastag">
                                            <td className="profile-pill">
                                                {hiddenFields.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                        onClick={() => toggleExpand(item.id ?? idx)}
                                                        aria-label="Show more details"
                                                    >
                                                        {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                    </button>

                                                )}

                                                <button
                                                    className="view-btn"
                                                    onClick={() => handleVideoContent(item)}
                                                >
                                                    <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                                </button>
                                            </td>
                                            <td className="pt-col-type"
                                            ><span className="real-badge">Video</span></td>
                                            {/* <td
                                            >
                                                <div className="chip">
                                                    <img
                                                        src={getImageUrl(item?.user?.avatar)}
                                                        alt=""
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                    <div>
                                                        <h5>{item?.user?.username}</h5>
                                                        <p>{item?.user?.name}</p>
                                                    </div>
                                                </div>
                                            </td> */}

                                            <td className="pt-col-user">
                                                <div className="profile-pill">
                                                    <div className="avatar">
                                                        <img
                                                            src={getImageUrl(item?.user?.avatar)}
                                                            alt=""
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className="username">{item?.user?.username}</div>
                                                        <div className="subtext">{item?.user?.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="pt-col-desc rr-actions4 col-hide-3">

                                                <div className="likecommentsposts">

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts?.length}</span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan">
                                                            <i class="bi bi-chat"></i>
                                                            <span>:</span>
                                                            {item.comments.length}
                                                        </span>

                                                    </div>

                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                    </div>
                                                    <div className="likecommentsdesign">

                                                        <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                    </div>
                                                </div>

                                                {/* <p className="alldescriptiontext">{item.description}</p> */}
                                                <p className="alldescriptiontext">
                                                    {renderDescription(item.description)}
                                                </p>
                                            </td>



                                            <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                            <td className="pt-col-action rr-actionsbutton col-hide-1">
                                                <CustomButton
                                                    reportclassName="rr-icon-btn green"
                                                    onClick={() => navigate(`/PostView/${item.id}`)}
                                                >
                                                    <i class="bi bi-eye"></i>
                                                </CustomButton>

                                                <CustomButton
                                                    reportclassName="rr-icon-btn green"
                                                    onClick={() => deleteadminalltype(item.id)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </CustomButton>
                                            </td>
                                        </tr>


                                        {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={6}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>
                                                                {field === "type" && (
                                                                    <span className="real-badge">Videos</span>
                                                                )}
                                                                {field === "user" && (
                                                                    <div className="profile-pill">
                                                                        <div className="avatar">
                                                                            <img
                                                                                src={getImageUrl(item?.user?.avatar)}
                                                                                alt=""
                                                                                style={{ width: 32, height: 32, borderRadius: "50%" }}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <div className="username">{item?.user?.username}</div>
                                                                            <div className="subtext">{item?.user?.name}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {field === "desc" && (
                                                                    <div>
                                                                        <div className="likecommentsposts">
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-suit-heart"></i><span>:</span>{item?.like_posts?.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-chat"></i>
                                                                                    <span>:</span>
                                                                                    {item.comments.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-bookmark"></i><span>:</span>{item?.save_posts.length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="likecommentsdesign">
                                                                                <span className="allspan">
                                                                                    <i className="bi bi-share"></i><span>:</span>{item.share_posts.length}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <p className="alldescriptiontext" style={{ margin: "8px 0 0" }}>
                                                                            {renderDescription(item.description)}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {field === "date" && (
                                                                    <span className="expand-value">
                                                                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                    </span>
                                                                )}
                                                                {field === "action" && (
                                                                    <div style={{ display: "flex", gap: 8 }}>
                                                                        <CustomButton reportclassName="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                                                                            <i className="bi bi-eye"></i>
                                                                        </CustomButton>
                                                                        <CustomButton reportclassName="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                                                                            <i className="bi bi-trash"></i>
                                                                        </CustomButton>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                        {/* </tbody> */}
                    </CustomTable>



                    <div className="rr-footer">
                        {activeType === "all" && (
                            <span>
                                Showing 1 to {posts.length} of {posts.length} entries
                            </span>
                        )}

                        {activeType === "reels" && (
                            <span>
                                Showing 1 to {userReels.length} of {userReels.length} entries
                            </span>
                        )}

                        {activeType === "posts" && (
                            <span>
                                Showing 1 to {userposts.length} of {userposts.length} entries
                            </span>
                        )}

                        {activeType === "text" && (
                            <span>
                                Showing 1 to {textposts.length} of {textposts.length} entries
                            </span>
                        )}

                        {activeType === "image" && (
                            <span>
                                Showing 1 to {imageposts.length} of {imageposts.length} entries
                            </span>
                        )}

                        {activeType === "video" && (
                            <span>
                                Showing 1 to {videoposts.length} of {videoposts.length} entries
                            </span>
                        )}




                        {/* <div className="rr-pagination">
                                {activeType === "all" && (
                                    <>
                                        <span
                                            className="rr-page-arrow"
                                            onClick={() => page > 1 && setPage(page - 1)}
                                        >
                                            &lt;
                                        </span>

                                       
                                        {Array.from({ length: totalPages || 0 }).map((_, i) => (

                                            <span
                                                key={i}
                                                className={`rr-page ${page === i + 1 ? "active" : ""}`}
                                                onClick={() => setPage(i + 1)}
                                            >
                                                {i + 1}
                                            </span>
                                        ))}

                                        <span
                                            className="rr-page-arrow"
                                            onClick={() => page < totalPages && setPage(page + 1)}
                                        >
                                            &gt;
                                        </span>
                                    </>
                                )}


                            </div> */}

                        {activeType === "all" && (
                            <CustomPagination
                                currentPage={page}
                                totalPages={totalPages}
                                onPageChange={(page) => setPage(page)}
                                className="rr-pagination"
                                pageClassName="rr-page"
                                activeClassName="active"
                                ellipsisClassName="rr-page"
                            />
                        )}



                    </div>
                </div>
            </CustomContainer>



            {isViewModalOpen && viewPost && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <div>
                            <button
                                className="close-btn"
                                onClick={() => setIsViewModalOpen(false)}
                            >
                                ✕
                            </button>

                            <h3 style={{ marginTop: "-5px" }}>View Content</h3>
                        </div>

                        {viewPost.text && <p>{viewPost.text}</p>}

                        <h3>
                            {viewPost.hashtags
                                ? JSON.parse(viewPost.hashtags).map((tag) => `#${tag}`).join(" ")
                                : ""}
                        </h3>

                        {viewPost.mentions && (
                            <p>
                                {JSON.parse(viewPost.mentions).map((m) => `@${m}`).join(" ")}
                            </p>
                        )}

                        {/* ---- POST CONTENT (SWIPER) ---- */}
                        <div className="content-preview" style={{ width: "100%" }}>
                            {(() => {
                                if (!viewPost.files) return <p>No media</p>;

                                const files = JSON.parse(viewPost.files);

                                return (
                                    <Swiper spaceBetween={10} slidesPerView={1} modules={[Pagination, Scrollbar, A11y]}
                                        navigation
                                        pagination={{ clickable: true }}
                                        scrollbar={{ draggable: true }}
                                    //   onSwiper={(swiper) => console.log(swiper)} 
                                    //   onSlideChange={() => console.log('slide change')}

                                    >
                                        {files.map((file, index) => {
                                            const fileUrl = `${ApiUrl}${file.uri.replace(
                                                /\\/g,
                                                "/"
                                            )}`;

                                            return (
                                                <SwiperSlide key={index}>
                                                    {file.type?.includes("image") ? (
                                                        <img
                                                            src={fileUrl}
                                                            style={{
                                                                width: "100%",
                                                                height: "400px",
                                                                objectFit: "cover",
                                                                borderRadius: 10,
                                                            }}
                                                        />
                                                    ) : file.type?.includes("video") ? (
                                                        <video
                                                            src={fileUrl}
                                                            controls
                                                            style={{
                                                                width: "100%",
                                                                height: "400px",
                                                                objectFit: "contain",
                                                                borderRadius: 10,
                                                            }}
                                                        />
                                                    ) : null}
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            )}

            <DeleteModal
    show={showDeleteModal}
    close={() => {
        setShowDeleteModal(false);
        setDeleteId(null);
        setDeleteHandler(null);
    }}
    onDelete={() => {
        if (deleteHandler && deleteId) {
            deleteHandler(deleteId);
        }
        setShowDeleteModal(false);
        setDeleteId(null);
        setDeleteHandler(null);
    }}
    title="Delete Content"
    message="Are you sure you want to delete this content?"
/>


        </Layout>
    );
}

